// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._154ize3t{top:var(--ds-space-0,0)}\n._1pbyowjs{z-index:300}\n._bfhk1j28{background-color:transparent}\n._kqswstnw{position:absolute}", ""]);
// Exports
module.exports = exports;
